import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false


import http from '@/api/index.js'

import './assets/scss/style.scss';
import  '@/assets/chart_theme/theme.js'

Vue.prototype.$http = http;


resetFont();
//设置字体REM
window.onresize = function() {
  resetFont();
}
function resetFont() {
  var deviceWidth = document.documentElement.clientWidth;
  document.documentElement.style.fontSize = deviceWidth / 19.2 + 'px';
}


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
